import React from "react";
import Typography from "@material-ui/core/Typography";
import SnackbarAlert from "../components/SnackbarAlert";
import {panelGeneralResources} from "../endpoints";
import TablaPanelAuditoriasAltilloDetalle from "../components/TablaPanelAuditoriasAltilloDetalle";
import TextField from "@mui/material/TextField";
import { useParams } from "react-router-dom";

function withParams(Component) {
  return (props) => {
    const params = useParams();
    return <Component {...props} params={params} />;
  };
}

class PanelAuditorias extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            disponibles: [],
            total: 0,
            paginationModel: { page: 0, pageSize: 25 },
            sortModel: [],   // 👈 IMPORTANTE
            search: "",
            centro: props.params?.centro || null ,  // 👈 AQUÍ
            mes: props.params?.mes || null   // 👈 AQUÍ

        };
    }
   
    componentDidMount(){
        this.obtenerDatos()
    }

    obtenerDatos = () => {
        const { page, pageSize } = this.state.paginationModel;
        const {centro,mes, search, sortModel } = this.state;

        const sortField = (sortModel && sortModel.length > 0) ? sortModel[0].field : undefined;
        const sortDir = (sortModel && sortModel.length > 0) ? sortModel[0].sort : undefined;

        panelGeneralResources
            .getAuditoriasPanelAltilloDetalle( centro,mes,page, pageSize, search, sortField, sortDir)
            .then(res => res.json())
            .then(data => {

            this.setState({
                disponibles: data.inv_disponibles,
                total: data.total
            });
        });
    };

    render() {
        return (
            <div>
                <Typography variant="h4" gutterBottom>Detalle Auditorias Altillo</Typography>
                <Typography variant="h5" gutterBottom>Centro: {this.state.centro} - Mes: {this.state.mes}</Typography>
                <TextField
                    label="Buscar"
                    variant="outlined"
                    size="small"
                    value={this.state.search}
                    onChange={(e) =>
                        this.setState(
                        { search: e.target.value, paginationModel: { ...this.state.paginationModel, page: 0 } },
                        this.obtenerDatos
                        )
                    }
                    style={{ marginBottom: 16 }}
                    />
                <TablaPanelAuditoriasAltilloDetalle
                    disponibles={this.state.disponibles}
                    total={this.state.total}
                    paginationModel={this.state.paginationModel}
                    sortingMode="server" // 👈 Crucial
                    sortModel={this.props.sortModel} // 👈 Esto hace que la flecha cambie visualmente
                    onPageChange={(model) =>
                        this.setState(
                            { paginationModel: model },
                            this.obtenerDatos
                        )
                    }
                    onSortChange={(model) => 
                        this.setState({ sortModel: model }, this.obtenerDatos)
                    }
                />               
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
            </div>
        )
    }
}

export default withParams(PanelAuditorias);